import React from 'react';
import type { ChangeEvent } from 'react';
import { Input } from '../../../../shared/components/ui/Input';
import { Box, InputAdornment, IconButton, useTheme } from '@mui/material';

interface InputFieldProps {
  label: string;
  type: string;
  value: string;
  onChange: (value: string) => void;
  onBlur: () => void;
  error?: boolean;
  errorMessage?: string;
  placeholder: string;
  icon: React.ReactNode;
  disabled?: boolean;
  showPasswordToggle?: boolean;
  onTogglePassword?: () => void;
  showPassword?: boolean;
}

export const InputField: React.FC<InputFieldProps> = ({
  label,
  type,
  value,
  onChange,
  onBlur,
  error,
  errorMessage,
  placeholder,
  icon,
  disabled,
  showPasswordToggle,
  onTogglePassword,
  showPassword,
}) => {
  const theme = useTheme();
  return (
    <Box sx={{ width: '100%', mb: 2 }}>
      <Input
        fullWidth
        label={label}
        type={type}
        value={value}
        onChange={(e: ChangeEvent<HTMLInputElement>) => onChange(e.target.value)}
        onBlur={onBlur}
        placeholder={placeholder}
        disabled={disabled}
        error={error}
        helperText={error && errorMessage}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              {icon}
            </InputAdornment>
          ),
          endAdornment: showPasswordToggle ? (
            <InputAdornment position="end">
              <IconButton
                onClick={onTogglePassword}
                edge="end"
                disabled={disabled}
                tabIndex={-1}
              >
                {showPassword ? (
                  <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                    <path d="M1 1l22 22"/>
                    <path d="M17.94 17.94A10.94 10.94 0 0 1 12 19c-5 0-9.27-3.11-11-7.5a11.05 11.05 0 0 1 5.17-5.61"/>
                    <path d="M9.53 9.53A3 3 0 0 0 12 15a3 3 0 0 0 2.47-5.47"/>
                  </svg>
                ) : (
                  <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                    <ellipse cx="12" cy="12" rx="10" ry="7"/>
                    <circle cx="12" cy="12" r="3"/>
                  </svg>
                )}
              </IconButton>
            </InputAdornment>
          ) : null,
        }}
        sx={{
          '& .MuiOutlinedInput-root': {
            backgroundColor: theme.palette.mode === 'dark'
              ? theme.palette.background.default
              : '#F9FAFB',
          },
        }}
      />
    </Box>
  );
};